import NotificationTable from '@/components/global-notification/NotificationTable';

export default function AllNotifications() {
	return (
		<div className="flex items-center h-full py-6 flex-col">
			<NotificationTable />
		</div>
	);
}
